"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderOrThrowError = exports.getModulesLengthError = exports.getModulesContentError = exports.getModulesContentAndLengthError = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _EditorialErrorMessage = require("../components/EditorialErrorMessage");
var _jsxRuntime = require("react/jsx-runtime");
const renderOrThrowError = (param)=>{
    let { debug, message, modulePosition, layout } = param;
    if (!debug) {
        return null;
    }
    if ((0, _presentationUtils.isSSR)()) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_EditorialErrorMessage.EditorialErrorMessage, {
            errorMessage: message,
            modulePosition: modulePosition,
            module: layout
        });
    }
    throw new Error(message);
};
exports.renderOrThrowError = renderOrThrowError;
const getModulesLengthError = (param)=>{
    let { debug, modulePosition, layout } = param;
    return renderOrThrowError({
        debug,
        message: "".concat(layout, " must have at least one module."),
        modulePosition,
        layout
    });
};
exports.getModulesLengthError = getModulesLengthError;
const getModulesContentError = (param)=>{
    let { debug, modulePosition, layout } = param;
    return renderOrThrowError({
        debug,
        message: "".concat(layout, " must have content."),
        modulePosition,
        layout
    });
};
exports.getModulesContentError = getModulesContentError;
const getModulesContentAndLengthError = (param)=>{
    let { debug, modulePosition, layout } = param;
    return renderOrThrowError({
        debug,
        message: "".concat(layout, " must have layout specified and have at least one module."),
        modulePosition,
        layout
    });
};
exports.getModulesContentAndLengthError = getModulesContentAndLengthError;
